/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createHex } from '../../factoriesAny.js';
export var hexDependencies = {
  typedDependencies,
  createHex
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesHex.generated.js
// module id = null
// module chunks = 